import { Box } from '@chakra-ui/react'
import React from 'react'

export const EditDoct = () => {
  return (
    <Box>
        <></>
    </Box>
  )
}
